import { render, staticRenderFns } from "./VideoRoomErrorModal.vue?vue&type=template&id=12f329e0&scoped=true&"
import script from "./VideoRoomErrorModal.vue?vue&type=script&lang=js&"
export * from "./VideoRoomErrorModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoRoomErrorModal.vue?vue&type=style&index=0&id=12f329e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f329e0",
  null
  
)

export default component.exports